import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next"; 
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import { useParams } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import GetRequestStyle from "../../components/helpers/GetRequestStyle";
import { FIELDS } from "../../components/utils/constants";
import GetServiceByCode from "../../components/helpers/GetServiceByCode";
import { CancellationReasons } from "../../components/utils/constants";
import ModalContainer from "../../containers/shared/ModalContainer";
import RadioInput from "../../components/shared/RadioInput";
import DownloadInvoice from "../../components/requests/DownloadInvoice";
import DownArrowIcon from "../../components/icons/down-arrow";
import { UserContext } from "../../App";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import Toast from "../../components/shared/Toast";
import InputField from "../../components/shared/InputField";
import TextArea from "../../components/shared/TextArea";
import NormalButton from "../../components/shared/NormalButton";

const SingleRequestPage = () => {
    const {t,i18n} = useTranslation();
    const { id } = useParams();
    const [singleRequest, setSingleRequest] = useState(null);
    useDocumentTitle(singleRequest ? `طلب رقم ${singleRequest?.prettyId}` : 'الطلبات');
    const pageTitle = {title: singleRequest ? `طلب رقم ${singleRequest?.prettyId}` : 'الطلبات', subTitle: ''};
    const [propertiesAndUnits, setPropertiesAndUnits] = useState(null);
    const [propertiesAndUnitsText, setPropertiesAndUnitsText] = useState(null);
    const [selectedCancellationReason, setSelectedCancellationReason] = useState('');
    const [selectedCancellationOption, setSelectedCancellationOption] = useState('');
    const [isCancelRequestDisabled, setIsCancelRequestDisabled] = useState(true);
    const [showCancelRequestModal, setShowCancelRequestModal] = useState(false);
    const [prevService, setPrevService] = useState(false);
    const [refreshWallet, setRefreshWallet] = useState(()=>new Date().getTime());
    const [isLoading, setIsLoading] = useState(()=>true);

    const [showHelpModal, setShowHelpModal] = useState(false);
    const EmptyTicketForm = {
        "complaintType": "SERVICE",
        "complaintSubject": "",
        "complaintText": ""
    }
    const [ticketForm, setTicketForm] = useState(EmptyTicketForm);
    const [errors, setErrors] = useState(null);
    const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(true);
    const [selectedRequestId, setSelectedRequestId] = useState(null);

    const [toast, setToast] = useState({show: false,type: null, message:'' });

    const [user,setUser] = useUser();

    const { fields } = useContext(UserContext);
    
    const getSingleRequest = async (singleId) => {
        try {
            const response = await apiClient.get(`/b-business-requests/${id}`);
            if(response?.data) {
                setIsLoading(false);
                setSingleRequest(response?.data);
                let propertyNames = [];
                let unitsNames = [];
                if(response?.data?.subRequests && Array.isArray(response?.data?.subRequests) && response?.data?.subRequests?.length > 0) {
                    response?.data?.subRequests?.map((subRequest, index) => {
                        propertyNames = [...propertyNames, subRequest?.propertyId?.name];
                        unitsNames = [...unitsNames, subRequest?.unitName];
                    });
                }
                setPropertiesAndUnits([propertyNames, unitsNames]);

            } else {

            }
        } catch(err) {}
    }

    useEffect(()=>{
        getSingleRequest();
    },[])

    useEffect(()=>{
        if(propertiesAndUnits && Array.isArray(propertiesAndUnits) && propertiesAndUnits?.length > 0) {
            let propertiesText;
            let unitsText;
            
            [...new Set(propertiesAndUnits[0])].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
            [...new Set(propertiesAndUnits[1])].map((u,i)=> i===0 ? unitsText = ''+u : unitsText += ' + ' + u);

            setPropertiesAndUnitsText([propertiesText, unitsText]);
        }
    },[propertiesAndUnits])


    const getFieldName = (request) => {
        if(request?.field?.name?.indexOf("'") > -1) {
            return request?.field?.name?.split("'")[1];
        } else {
            if(request?.field?.name) {
                return request?.field?.name;
            } else {
                return request?.field;
            }
        }
    }

    const getCodeFromSubRequest = (subRequest) => {
        if(subRequest?.initialWorkList && 'initialWorkList' in subRequest) {
            return subRequest?.initialWorkList?.maintenanceCode;
        } else {
            return subRequest?.serviceDetails?.subServiceCode;
        }
    }

    const sumPartsCosts = (request) => {
        let total = 0;
        if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0) {
            request?.subRequests?.forEach(sub=>{
                total = total + sub?.invoiceDetails?.partsCost;
            });
        }
        return total;
    }

    const sumPartsCostsDelivery = (request) => {
        let total = 0;
        if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0) {
            request?.subRequests?.forEach(sub=>{
                total = total + sub?.invoiceDetails?.deliveryCostOfParts;
            });
        }
        return total;
    }

    const handleClickCancelRequest = () => {
        setSelectedCancellationReason('');
        setSelectedCancellationOption('');
        setShowCancelRequestModal(true);
    }

    const handleCloseCancelRequestModal = () => {
        setShowCancelRequestModal(false);
    }

    const handleClickCancelRequestAction = async() => {
        setIsCancelRequestDisabled(true);
         try {
            const response = await apiClient.patch(`/b-business-requests/${singleRequest?._id}/cancel`,{"cancellationReason": selectedCancellationReason});
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setShowCancelRequestModal(false);
                getSingleRequest();
            }
        } catch(err) {}
    }

    useEffect(()=>{
        if (typeof selectedCancellationReason === 'string' && selectedCancellationReason?.length > 3) {
            setIsCancelRequestDisabled(false);
        } else {
            setIsCancelRequestDisabled(true);
        }
    },[selectedCancellationReason])

    const AcceptSubRequestPriceEditing = async (id) => {
        setIsLoading(true);
        try {
            const response = await apiClient.patch(`/b-business-requests/sub-request/${id}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setIsLoading(false);
                getSingleRequest();
                setTimeout(()=>setRefreshWallet(new Date().getTime()),500);
            }
        } catch(err) {}

    }

    const AcceptRequestPriceEditing = async (id) => {
        setIsLoading(true);
         try {
            const response = await apiClient.patch(`/b-business-requests/${id}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                setIsLoading(false);
                getSingleRequest();
                setTimeout(()=>setRefreshWallet(new Date().getTime()),500);
            }
        } catch(err) {}


    }


    const getFieldNameAr = (field) => {
        if(fields) {
            return fields?.find(f=>f?.field?.code === field)?.field?.name?.ar;
        } else {
            return FIELDS[field]?.ar;
        }
    }

    const getFieldIcon = (field) => {
        if(FIELDS[field]?.icon) {
            return "url('/assets/images/"+FIELDS[field]?.icon+"')";
        } else {
            return "url('"+fields?.find(f=>f?.field?.code === field)?.field?.url+"')";
        }
    }

    const getFieldCategoryAr = (field,subFieldCode) => {
        if(fields) {
            let fieldCategory;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        fieldCategory = d?.device?.name?.ar;
                    }
                })
            })
            return fieldCategory;
        } else {
            return GetServiceByCode(field, subFieldCode)[0];
        }
    }

    const getSubFieldAr = (field,subFieldCode) => {
        if(fields) {
            let subField;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        subField = m?.name?.ar;
                    }
                })
            })
            return subField;
        } else {
            return GetServiceByCode(field, subFieldCode)[1];
        }
    }


    const handleClickShowHelpModal = (id) => {
        setTicketForm(EmptyTicketForm);
        setShowHelpModal(true);
        setSelectedRequestId(id);
    }

    const handleClickCloseHelpModal = () => {
        setShowHelpModal(false);
    }

    const handleClickSendTicket = async () => {
        setIsLoading(true);
        try {
            const response = await apiClient.post(`/b-users/${selectedRequestId}/send-complaint-from-business`,ticketForm);
            if([200,201,204].includes(response?.status)) {
                setShowHelpModal(false);
                setIsLoading(false);
                setToast({show:true,type:'success',message:'تم إرسال الشكوي بنجاح'});
            } else {
                setIsLoading(false);
                setToast({show:true,type:'error',message:'حدث خطأ في إرسال الشكوي'});
            }
        } catch(err) {
            setIsLoading(false);
            setToast({show:true,type:'error',message:err?.response?.data?.message});
        }
    }

    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    useEffect(()=>{
        if(ticketForm && ticketForm?.complaintSubject && ticketForm?.complaintText && ticketForm?.complaintSubject.toString().length > 3 && ticketForm?.complaintText.toString().length > 3) {
            setIsActionButtonDisabled(false);
        } else {
            setIsActionButtonDisabled(true);
        }
    },[ticketForm])


  return (
    singleRequest && <div>
      <PageHeader key={refreshWallet} pageTitle={pageTitle} isColored />
      <PageMain>
        <div className="fixed top-0 left-0 w-full h-full bg-grey-50 !z-[-1]"></div>
        <MainContent>
            <div className="bg-white rounded-[8px] overflow-hidden mb-[25px]">

                <div className={`${GetRequestStyle(singleRequest?.status,'bg')} text-white h-[56px] p-[16px] mb-[10px]`}>
                    <h2 className="text-[16px] font-[600]">{GetRequestStyle(singleRequest?.status,'heading')}</h2>
                </div>

                <p className="text-[16px] text-grey-900 font-[700] px-[16px]">تفاصيل الطلب</p>
                <div className="">
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] px-[16px]">
                        <span className="inline-block align-middle w-[20px] h-[20px] me-[4px] !bg-center !bg-no-repeat" style={{background:"url('/assets/images/note.svg')", backgroundSize: "20px"}}></span>
                        <span className="text-[12px] text-grey-900 font-[600]">رقم الطلب:</span> {singleRequest?.prettyId}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="inline-block align-middle w-[20px] h-[20px] me-[4px] !bg-center !bg-no-repeat" style={{background:"url('/assets/images/calendar.svg')", backgroundSize: "20px"}}></span>
                        <span className="text-[12px] text-grey-900 font-[600]">تاريخ الانشاء:</span> {new Date(singleRequest?.createdAt).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'})}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="inline-block align-middle w-[20px] h-[20px] me-[4px] !bg-center !bg-no-repeat" style={{background:"url('/assets/images/user-square.svg')", backgroundSize: "20px"}}></span>
                        <span className="text-[12px] text-grey-900 font-[600]">أنشئ بواسطة:</span> {singleRequest?.statuses[0]?.createdBy?.name}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="inline-block align-middle w-[20px] h-[20px] me-[4px] !bg-center !bg-no-repeat" style={{background:"url('/assets/images/main-property-icon.svg')", backgroundSize: "20px"}}></span>
                        <span className="text-[12px] text-grey-900 font-[600]">المنشأة:</span> {propertiesAndUnitsText && propertiesAndUnitsText[0]}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="inline-block align-middle w-[20px] h-[20px] me-[4px] !bg-center !bg-no-repeat" style={{background:"url('/assets/images/house.svg')", backgroundSize: "20px"}}></span>
                        <span className="text-[12px] text-grey-900 font-[600]">الوحدة:</span> {propertiesAndUnitsText && propertiesAndUnitsText[1]}
                    </div>
                </div>

            </div>

            <div className="bg-white rounded-[8px] overflow-hidden mb-[15px]">
                <p className="text-[24px] leading-[36px] text-grey-900 font-[700] mx-[16px] py-[16px] border-b-[1px] border-b-grey-200">الخدمات المطلوبة</p>
                {singleRequest?.subRequests && 'subRequests' in singleRequest && singleRequest?.subRequests[0]?.initialWorkList ?
                singleRequest?.subRequests?.map((subRequest, index)=> {
                        return (
                        <div key={`subrequest-${index}`}>
                            <div className={`p-[16px] bg-grey-50 m-[16px] border-[1px] border-grey-200 rounded-[8px] relative ${subRequest?.paymentStatus === 'paid' ? 'pb-[60px]':''}`}>
                                <div className="flex flex-nowrap mb-[10px] border-b-[1px] border-b-grey-200">
                                    <div className="w-[50%] text-[12px] text-grey-900 font-[600] pb-[16px]">رقم الطلب الفرعي: <span dir="ltr" className="font-[500] text-[14px] text-grey-600">{subRequest?.prettyId}</span></div>

                                    <div className="w-[50%] text-end">
                                    حالة الطلب الفرعي: <span className={`${GetRequestStyle(subRequest?.status,'bg')} text-white font-bold px-[10px] rounded-[3px]`}>{GetRequestStyle(subRequest?.status,'label')}</span>
                                    </div>
                                </div>
                            {subRequest?.status === 'awaiting-price-confirmation' ? subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.subFields?.map((service,index)=>{
                            return (
                                <div key={`initialWorkList-${subRequest?._id}-${index}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                    <div className="w-full max-w-[228px]">
                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                        <div className="inline-block align-middle">
                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field)}</p>
                                        </div>
                                    </div>
                                <div className="w-full max-w-[180px]">
                                        <p className="text-[#616161]">نوع الخدمة</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">الكمية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                    </div>
                                </div>
                                )
                        }) 
                    : subRequest?.initialWorkList?.map((service,i)=>{
                                    return (
                                        <div key={`sub-${i}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                            <div className="w-[25%]">
                                                <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(subRequest?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                                <div className="inline-block align-middle">
                                                    <p className="text-[#616161]">الخدمة الأساسية</p>
                                                    <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(subRequest?.field)}</p>
                                                </div>
                                            </div>
                                            <div className="w-[25%]">
                                                <p className="text-[#616161]">نوع الخدمة</p>
                                                <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(subRequest?.field, service?.maintenanceCode)}</p>
                                            </div>
                                            <div className="w-[25%]">
                                                <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                                <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(subRequest?.field, service?.maintenanceCode)}</p>
                                            </div>
                                            <div className="w-[25%]">
                                                <p className="text-[#616161]">الكمية</p>
                                                <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                            </div>
                                        </div>
                                    )})}
                                <div className="flex flex-nowrap mb-[10px]">
                                    <div className="w-full text-[16px] text-grey-900 font-[600]">اسم الوحدة</div>
                                </div>
                                <div>
                                    <div className="inline-block align-middle px-[8px] rounded-[8px] h-[32px] leading-[32px] text-grey-900 font-[500] text-[16px] bg-[rgba(30,41,59,0.1)] me-[10px]">
                                        {subRequest?.unitName}
                                    </div>
                                </div>
                                {subRequest?.notes ? <div className="text-[14px] text-grey-600 font-[500] my-[16px]">
                                    <h4 className="text-[14px] text-grey-600 font-[400] mb-[8px]">ملاحظات الخدمة:</h4> 
                                    <p className="font-[500] text-[14px] text-grey-600">
                                        {subRequest?.notes?.notes || 'غير معرف'}
                                    </p>
                                </div> : ''} 
                                <div className="border-t-[1px] border-t-grey-200 mt-[16px]">
                                    <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                                        <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي قطع الغيار المطلوبة</div>
                                        <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{subRequest?.status === 'awaiting-price-confirmation' ? subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.partsCost.toFixed(2) : subRequest?.invoiceDetails?.partsCost?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                                    </div>
                                    {subRequest?.invoiceDetails?.partsCost && subRequest?.invoiceDetails?.partsCost > 0 ? <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                                        <div className="w-[50%] text-[16px] text-grey-600 font-[500]">رسوم توصيل قطع الغيار</div>
                                        <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{subRequest?.status === 'awaiting-price-confirmation' ? subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.deliveryCostOfParts.toFixed(2) : subRequest?.invoiceDetails?.deliveryCostOfParts?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                                    </div> : ''}
                                    <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                                        <div className="w-[50%] text-[16px] text-grey-600 font-[500]">راتب  العمالة بدون ضريبة</div>
                                        <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{subRequest?.status === 'awaiting-price-confirmation' ? subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.workerWage.toFixed(2) : subRequest?.invoiceDetails?.workerWage?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                                    </div>
                                    <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                                        <div className="w-[50%] text-[16px] text-grey-600 font-[500]">الضريبة</div>
                                        <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{subRequest?.status === 'awaiting-price-confirmation' ? subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.vatValue.toFixed(2) : subRequest?.invoiceDetails?.vatValue?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                                    </div>
                                    <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                                        <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي تكلفة الطلب الفرعي</div>
                                        <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{subRequest?.status === 'awaiting-price-confirmation' ? subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.total.toFixed(2) : subRequest?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                                    </div>
                                </div>
                                {subRequest?.status === 'done' && <DownloadInvoice subRequestId={subRequest?._id} prettyId={subRequest?.prettyId} />}

                                {/* if there is a price change */}
                                {subRequest?.status === 'awaiting-price-confirmation' ? <div  className={`bg-grey-200 my-[15px] rounded-[8px] relative max-h-[42px] transition-all duration-300 overflow-hidden border-y border-[transparent] ${prevService ? '!max-h-[1000px]' : ''}`}>
                                    <div className="cursor-pointer h-[42px] leading-[42px] flex flex-nowrap select-none px-[16px]" onClick={()=> setPrevService(prev=>!prev)}>
                                        <div className="w-[75%] text-[17px] font-[600] text-grey-900">تفاصيل الخدمة المعدلة</div>
                                        <div className="w-[25%] text-end"><DownArrowIcon revarse={prevService} /></div>
                                    </div>
                                    {subRequest?.subRequestActivityLogs && Array.isArray(subRequest?.subRequestActivityLogs) && subRequest?.subRequestActivityLogs?.length > 0 ? 
                                    <div className="pt-[16px] px-[16px] opacity-50">
                                        {subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.subFields && subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.subFields?.map((service,i)=>{
                                            return (
                                                <div key={`sub-request-activity-log-${i}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                                    <div className="w-full max-w-[228px]">
                                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                                        <div className="inline-block align-middle">
                                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-full max-w-[180px]">
                                                        <p className="text-[#616161]">نوع الخدمة</p>
                                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field, service?.maintenanceCode)}</p>
                                                    </div>
                                                    <div className="w-full max-w-[280px]">
                                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field, service?.maintenanceCode)}</p>
                                                    </div>
                                                    <div className="w-full max-w-[280px]">
                                                        <p className="text-[#616161]">الكمية</p>
                                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                                    </div>
                                                </div>
                                            )}
                                        )}
                                        <div className="flex flex-nowrap mb-[10px]">
                                            <div className="w-full text-[16px] text-grey-900 font-[600]">الوحدات</div>
                                        </div>
                                        <div>
                                            <div className="inline-block align-middle px-[8px] rounded-[8px] h-[32px] leading-[32px] text-grey-900 font-[500] text-[16px] bg-[rgba(30,41,59,0.1)] me-[10px]">
                                                {subRequest?.unitName}
                                            </div>
                                        </div>
                                        <div className="h-[24px] leading-[24px] my-[17px] flex flex-nowrap select-none">
                                            <div className="w-[75%] text-[17px] font-[600] text-grey-900">اجمالي الفاتورة القديمة</div>
                                            <div className="w-[25%] text-end font-bold ">{subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                                        </div>
                                    </div>: ''}
                                </div> : ''}

                                {subRequest?.status === 'awaiting-price-confirmation' && subRequest?.subRequestActivityLogs[subRequest?.subRequestActivityLogs?.length-1]?.needConfirmation && user?._id === singleRequest?.createdBy?._id ? <div className="text-end">
                                    <div className="w-[166px] h-[48px] leading-[48px] bg-darkBlue text-white border-[1px] border-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={()=>AcceptSubRequestPriceEditing(subRequest?._id)}>التأكيد و الدفع</div>
                                </div> : ''}

                                {['done','reviewed'].includes(subRequest?.status) ?
                                    <div className="absolute bottom-[14px] end-[160px] text-end">
                                        <div className="w-[160px] h-[30px] leading-[30px] bg-none text-darkBlue border-[1px] border-dartext-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[14px] font-[600]" onClick={()=>handleClickShowHelpModal(subRequest?._id)}>احتاج إلى مساعدة</div>
                                    </div> : ''
                                }
                            </div>
                        </div>)
                })
                : ''}
            </div>

            <div className="bg-white rounded-[8px] overflow-hidden">
                <p className="text-[24px] leading-[36px] text-grey-900 font-[700] mx-[16px] py-[16px] border-b-[1px] border-b-grey-200 border-dotted">تفاصيل الفاتورة</p>
                  
                <div className="px-[16px] pb-[16px]">
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي قطع الغيار المطلوبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{singleRequest?.status === 'awaiting-price-confirmation' ? singleRequest?.requestActivityLogs[singleRequest?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.partsCost?.toFixed(2) : singleRequest?.invoiceDetails?.partsCost?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                        {sumPartsCosts(singleRequest) > 0 && <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي رسوم توصيل قطع الغيار</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{singleRequest?.status === 'awaiting-price-confirmation' ? singleRequest?.requestActivityLogs[singleRequest?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.deliveryCostOfParts?.toFixed(2) : singleRequest?.invoiceDetails?.deliveryCostOfParts?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>}
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي راتب العمالة بدون ضريبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{singleRequest?.status === 'awaiting-price-confirmation' ? singleRequest?.requestActivityLogs[singleRequest?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.workersWage?.toFixed(2) : singleRequest?.invoiceDetails?.workersWage?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">الضريبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{singleRequest?.status === 'awaiting-price-confirmation' ? singleRequest?.requestActivityLogs[singleRequest?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.vatValue?.toFixed(2) : singleRequest?.invoiceDetails?.vatValue?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي تكلفة الطلب</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{singleRequest?.status === 'awaiting-price-confirmation' ? singleRequest?.requestActivityLogs[singleRequest?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.total?.toFixed(2) : singleRequest?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                </div>
                

            </div>

            <div className="h-[25px]"></div>

            <div className="mx-[-25px] bg-white w-[calc(100%+50px])] h-[87px] text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                {singleRequest?.status === 'awaiting-price-confirmation' && singleRequest?.requestActivityLogs[singleRequest?.requestActivityLogs?.length-1]?.needConfirmation && user?._id === singleRequest?.createdBy?._id && <div className="w-[166px] h-[48px] leading-[48px] bg-darkBlue text-white border-[1px] border-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={()=>AcceptRequestPriceEditing(singleRequest?._id)}>التأكيد و الدفع</div>}
                {singleRequest?.status === 'pending' && <div className="w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={handleClickCancelRequest}>الغاء الطلب</div>}
            </div>
          
        </MainContent>
      </PageMain>
      {isLoading && <Loading showLoading={true} />}


      {showCancelRequestModal && <ModalContainer maxWidth={'775px'} heading="إلغاء طلب مستفيد" handleCloseModal={handleCloseCancelRequestModal}>
                  
            <div className=" border-b-[1px] border-grey-100 leading-[70px]">
                <p className="font-[400] text-[16px] text-grey-600">من فضلك قم باختيار سبب الإلغاء حتى يتم إبلاغ مسؤول الوحدة</p>
            </div>

            <div className="">
                <RadioInput name={'cancellationReasons-'+singleRequest?._id} options={CancellationReasons} onChange={(value)=>setSelectedCancellationReason(value)} value={selectedCancellationReason} onSelect={setSelectedCancellationOption} selected={selectedCancellationOption} />
            </div>

            <div className="w-full h-[70px] bg-white text-end pt-[20px] border-t-[1px] border-grey-100">
                    <div className={`w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] ${isCancelRequestDisabled ? 'opacity-50 pointer-events-none' : ''}`} onClick={isCancelRequestDisabled ? null : handleClickCancelRequestAction}>الغاء الطلب</div>
                </div>

        </ModalContainer>}

        {showHelpModal && <ModalContainer maxWidth={'775px'} heading="من فضلك قم بتعبئة البيانات التالية لرفع شكوى" handleCloseModal={handleClickCloseHelpModal}>
                
                <div className=" border-b-[1px] border-grey-100 leading-[70px]">
                    <p className="font-[400] text-[16px] text-grey-600">سيتم ارسال الشكوي الي الدعم وسيقوم احد عملائنا بالتواصل معك في اقرب وقت ممكن</p>
                </div>
    
                <div className="pt-[24px]">
                    <InputField isRequird label={`موضوع الشكوى`} placeholder={'من فضلك اكتب موضوع الشكوي'} value={ticketForm?.complaintSubject} error={errors?.complaintSubject} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setTicketForm({ ...ticketForm, complaintSubject: e.target.value }); hideError('complaintSubject')}} />
                </div>
    
                <div className="pb-[14px] pt-[14px]">
                    <TextArea isRequird label={`تفاصيل الشكوى`} placeholder={'اكتب موضوع الشكوي لنتمكن من مساعدتك'} value={ticketForm?.complaintText} error={errors?.complaintText} errorMessage={errors?.complaintText} translateError={true} onChange={(e)=>{ setTicketForm({ ...ticketForm, complaintText: e.target.value }); hideError('complaintText')}} />
                </div>
    
                <div className="w-full h-[70px] bg-white text-end pt-[20px] border-t-[1px] border-grey-100">
                    <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleClickCloseHelpModal}>إلغاء</div>
                    <NormalButton isDisabled={isActionButtonDisabled} label={'ارسال الشكوي'} onClick={handleClickSendTicket} />
                </div>
    
            </ModalContainer>}

        <Toast toast={toast} setToast={setToast} />


    </div>
  );
};

export default SingleRequestPage;